import $ from 'jquery';

$(document).ready(() => {
	/**
	 * Working class member
	 */
	const worker = (selector, searcharray) => {
		let foundElements = 0;
		$(selector).each((idx, elem) => {
			const $elem = $(elem);

			if (searcharray.indexOf($elem.val()) > -1) {
				$elem.addClass('selected');
				foundElements++;
			}
		});
		if (foundElements > 0) {
			$(`${selector}[value=all]`).removeClass('selected');
		}
	};
	/**
	 * After Loading, activate selection visually
	 */
	const startUp = () => {
		if ($('.data-block').length > 0) {
			const locations = $('.data-block #filter-locations').val().split(',');
			const companies = $('.data-block #filter-companies').val().split(',');
			const types = $('.data-block #filter-types').val().split(',');

			worker('form button.type-select', types);
			worker('form button.company-select', companies);
			worker('form button.location-select', locations);

			if (types[0] !== '' || companies[0] !== '' || locations[0] !== '') {
				window.scrollTo({
					top: 800,
				});
			}
		}
	};
	startUp();

	/**
	 * Workers:
	 */
	$('form .reset-button')
		.off('click')
		.on('click', (evt) => {
			evt.preventDefault();
			const form = $(evt.target).parents('form');

			form.find('.subject').val('');
			form.find('.data-block #filter-locations').val('all');
			form.find('.data-block #filter-companies').val('all');
			form.find('.data-block #filter-types').val('all');
			form.submit();
		});

	/**
	 * Direct visual feedback on buttons
	 * @param $target the selected button as jquery object
	 * @param preselect selector string
	 */
	const visualFeedback = ($target, preselect) => {
		if ($target.val() !== 'all') {
			if ($target.hasClass('selected')) {
				$target.removeClass('selected');
				let counter = 0;

				$(preselect).each((idx, elem) => {
					const $targ = $(elem);
					if ($targ.hasClass('selected')) {
						counter++;
					}
				});

				if (counter === 0) {
					$(preselect).each((idx2, elem2) => {
						const $elem = $(elem2);
						if ($elem.val() === 'all') {
							$elem.addClass('selected');
						}
					});
				}
			} else {
				$target.addClass('selected');
				$(preselect).each((idx, elem) => {
					const $targ = $(elem);
					if ($targ.val() === 'all') {
						$targ.removeClass('selected');
					}
				});
			}
		} else {
			$target.addClass('selected');
			$(preselect).each((idx, elem) => {
				const $targ = $(elem);
				if ($targ.val() !== 'all') {
					$targ.removeClass('selected');
				}
			});
		}
	};
	/**
	 *
	 */
	const transferToData = () => {
		const $types = $('form button.type-select');
		const $companies = $('form button.company-select');
		const $locations = $('form button.location-select');
		let list;

		list = [];
		$types.each((idx, elem) => {
			if ($(elem).hasClass('selected')) {
				list.push($(elem).val());
			}
		});
		$('form #filter-types').val(list.join(','));

		list = [];
		$companies.each((idx, elem) => {
			if ($(elem).hasClass('selected')) {
				list.push($(elem).val());
			}
		});
		$('form #filter-companies').val(list.join(','));

		list = [];
		$locations.each((idx, elem) => {
			if ($(elem).hasClass('selected')) {
				list.push($(elem).val());
			}
		});
		$('form #filter-locations').val(list.join(','));
	};

	/**
	 * And now the jquery work schedule
	 */

	$('form button.type-select')
		.off('click')
		.on('click', (evt) => {
			const $this = $(evt.target);
			visualFeedback($this, 'form button.type-select');
			transferToData();
			const form = $this.parents('form');
			form.submit();
		});

	$('form button.company-select')
		.off('click')
		.on('click', (evt) => {
			const $this = $(evt.target);
			visualFeedback($this, 'form button.company-select');
			transferToData();
			const form = $this.parents('form');
			form.submit();
		});

	$('form button.location-select')
		.off('click')
		.on('click', (evt) => {
			const $this = $(evt.target);
			visualFeedback($this, 'form button.location-select');
			transferToData();
			const form = $this.parents('form');
			form.submit();
		});
});
